export default __webpack_public_path__ + "static/media/sensotrend_connect_select_devices.02383f31.png";